import script from "./EvidenceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./EvidenceDetail.vue?vue&type=script&setup=true&lang=js"

import "./EvidenceDetail.vue?vue&type=style&index=0&id=40d35c6f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40d35c6f"]])

export default __exports__